import { render, staticRenderFns } from "./CompetitionEntry.vue?vue&type=template&id=4be29476&scoped=true"
import script from "./CompetitionEntry.vue?vue&type=script&lang=js"
export * from "./CompetitionEntry.vue?vue&type=script&lang=js"
import style0 from "./CompetitionEntry.vue?vue&type=style&index=0&id=4be29476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be29476",
  null
  
)

export default component.exports